import { render, staticRenderFns } from "./autotest.vue?vue&type=template&id=1cad134e&scoped=true"
import script from "./autotest.vue?vue&type=script&lang=js"
export * from "./autotest.vue?vue&type=script&lang=js"
import style0 from "./autotest.vue?vue&type=style&index=0&id=1cad134e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cad134e",
  null
  
)

export default component.exports